<template>
    <BaseTooltip v-if="!canLeave" open-on-click>
        <template #trigger>
            <span role="button" aria-disabled="true" tabindex="0" :aria-label="t('teamPerspective.leave.action')" :aria-describedby="helpId">
                <BaseButton theme="neutral" size="sm" class="pointer-events-none" aria-hidden="true" disabled>{{ t("teamPerspective.leave.action") }}</BaseButton>
            </span>
        </template>
        <template #content>{{ t("teamPage.leadLeaveHelp") }}</template>
    </BaseTooltip>
    <LeaveTeamDialog v-else :team-name="teamName" :leave-url="leaveUrl" :disabled="disabled" theme="neutral" size="sm" @left="emit('left')" />
    <span v-if="!canLeave" :id="helpId" class="sr-only">{{ t("teamPage.leadLeaveHelp") }}</span>
</template>
<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import BaseTooltip from "~vue/components/BaseTooltip.vue";
import LeaveTeamDialog from "~vue/Connections/LeaveTeamDialog.vue";
import { useId } from "vue";
import { useI18n } from "vue-i18n";

defineProps<{ canLeave: boolean; teamName: string; leaveUrl: string; disabled: boolean }>();
const emit = defineEmits<{ left: [] }>();
const { t } = useI18n();
const helpId = useId();
</script>
